import {
  Avatar,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  styled,
} from "@/components";

const StyledCard = styled(Card)(({ theme }) => ({
  height: `calc(100vh - ${theme.spacing(2)})`,
  display: "flex",
  flexDirection: "column",
  position: "absolute",
  right: theme.spacing(1),
  left: theme.spacing(1),
  transition: theme.transitions.create(["bottom", "opacity"], {
    duration: theme.transitions.duration.shorter,
  }),
  variants: [
    {
      props: ({ expand = "false" }) => !Boolean(expand.replace(/false/, "")),
      style: {
        bottom: "-50vh",
        opacity: 0,
      },
    },
    {
      props: ({ expand = "false" }) => Boolean(expand.replace(/false/, "")),
      style: {
        bottom: theme.spacing(1),
        opacity: 1,
      },
    },
  ],
}));

const StyledCardHeader = styled(CardHeader)(({ theme }) => ({
  position: "relative",
  zIndex: 1,
  padding: theme.spacing(1),
  background: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  boxShadow: "0 1px 3px 0 rgba(0,0,0,.3)",
  '& [class$="-action"]': {
    marginRight: theme.spacing(-0.4),
  },
}));

const StyledCardContent = styled(CardContent)(({ theme }) => ({
  display: "flex",
  alignItems: "end",
  flexGrow: 1,
  padding: 0,
}));

const StyledCardActions = styled(CardActions)(({ theme }) => ({
  position: "relative",
  borderTop: `1px solid ${theme.palette.gray2.main}`,
  boxShadow: "0 0 3px 0 rgba(0,0,0,.2)",
  background: theme.palette.background.default,
}));

const StyledAvatar = styled(Avatar)(({ theme }) => ({
  width: 38,
  height: 38,
  margin: theme.spacing(-0.4, 0),
  background: theme.palette.background.default,
}));

const StyledInput = styled("input")(({ theme }) => ({
  all: "unset",
  flex: 1,
  margin: theme.spacing(0, 1, 0, 0),
  padding: theme.spacing(0.5),
}));

const StyledFrame = styled("iframe")(() => ({
  height: "100%",
  border: "unset",
}));

const StyledMinimized = styled("div")(({ theme }) => ({
  position: "absolute",
  right: theme.spacing(1),
  bottom: theme.spacing(1),
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  background: "transparent",
  '& .badge': {
    width: 60,
    height: 60,
    borderRadius: "50%",
    background: `#fff url('/static/images/avatar/1_cut.png') center/cover no-repeat`,
    boxShadow: "0 2px 12px rgba(0,0,0,0.25)",
    cursor: "pointer",
  },
}));

export {
  StyledCard,
  StyledCardHeader,
  StyledCardContent,
  StyledCardActions,
  StyledAvatar,
  StyledInput,
  StyledFrame,
  StyledMinimized,
};
